import { useState, useEffect } from "react";
import CommandsQueries from '../../../../../requests/queries/CommandsQueries'
import { useParams, Link } from "react-router-dom";
import LoadingSpinner from "../../../../common/Loading";
import ProtectedPage from "../../../../common/ProtectedPage";
import ClientHeader from "../../../../common/ClientHeader";
import { CategoriesQueriesClient } from '../../../../../requests/queries/CategoriesQueries';
import './CancelPageStyles.css';
import Sidebar from "../../../../common/Sidebar";

export default function CancelPage({ currentCommand, setCurrentCommand }) {
    
    const { id } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [command, setCommand] = useState(null);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        CommandsQueries.findById(id).then((res) => {
            setCommand(res.data.command);
            setIsLoading(false);
        }).catch((err) => {
            setError(err.response?.data?.message || 'An error occurred');
            setIsLoading(false);
        });
    }, [id]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await CategoriesQueriesClient.findAll();
                setCategories(res.data.categories);
            } catch (err) {
                console.error("Erreur lors du chargement des catégories:", err);
            }
        };
        fetchCategories();
    }, []);

    if(isLoading) {
        return <LoadingSpinner />;
    }

    if(error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    return (
        <ProtectedPage needToBeAuthenticated={false} redirectPath="/client-auth">
            <div className="patricians-layout">
                <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
                <div className="patricians-main-content">
                    {/* Sidebar gauche avec catégories */}
                    <Sidebar />

                    <div className="cancel-page-container">
                        <h1>Payment cancelled</h1>
                        <p className="cancel-page-subtitle">Order ID: {command.id}</p>
                        <p className="cancel-page-subtitle">Date: {new Date(command.created_at).toLocaleDateString('en-GB', { 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}</p>
                        
                        <div className="cancel-message-box">
                            <p className="cancel-message-text">
                                Votre paiement a été annulé. Aucun montant n'a été débité.
                            </p>
                            <p className="cancel-message-info">
                                If you want to try again, you can return to your cart and complete your order again.
                            </p>
                        </div>

                        {command.products && command.products.length > 0 ? (
                            <div className="cancel-page-products-container">
                                <h2 className="cancel-products-title">Order products</h2>
                                {command.products.map((product) => (
                                    <div className="cancel-page-product-card" key={product.id}>
                                        <div className="cancel-page-product-image">
                                            <img src={product.images[0]?.image_url || 'https://via.placeholder.com/300x300?text=Image'} alt={product.name} />
                                        </div>
                                        <p className="cancel-page-product-name">{product.name}</p>
                                        <p className="cancel-page-product-quantity">{product.variants?.reduce((total, variant) => total + variant.quantity, 0) || 0}</p>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="cancel-page-products-container">
                                <p className="cancel-page-subtitle">No products in this order</p>
                            </div>
                        )}

                        <div className="cancel-action-buttons">
                            <Link to={`/client/checkout`} className="btn-retry">
                                Back to cart
                            </Link>
                            <Link to="/shop" className="btn-continue">
                                Continue shopping
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedPage>
    );
}
